import React from 'react';
import SubPage from '#/common/components/SubPage';
import Alerts from '../components/Alerts';

const AlertsPage: React.FC = () => {
  return (
    <SubPage title="Alerts">
      <Alerts />
    </SubPage>
  );
};

export default React.memo(AlertsPage);
